"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGameData = exports.addDefaultFlowers = exports.addDefaultTrees = exports.GlobalGameData = exports.ShopItemData = exports.WALK_TO_HOUSE_PATHS = exports.NOM_TOOK_WALK_TO_YOU = exports.TOM_NOOK_SHOP_POSITION = exports.START_POSITIONS = exports.PlatableGameData = exports.ItemTypeInventoryActionLookup = void 0;
const types_1 = require("./types");
const Utils_1 = require("./Utils");
const BedFurnitureData = {
    type: types_1.ItemTypes.FURNITURE,
    shop: {
        shopPrice: 1000,
        sellPrice: 500,
    }
};
const ToolData = {
    type: types_1.ItemTypes.TOOL,
};
const SeedInventoryData = {
    type: types_1.ItemTypes.PLANTABLE,
};
const DropArray = ['drop'];
exports.ItemTypeInventoryActionLookup = {
    [types_1.ItemTypes.TOOL]: ['equip'],
    [types_1.ItemTypes.RESOURCE]: { 'info': 'sell this to nom took' },
    [types_1.ItemTypes.BUG]: { 'info': 'sell this to nom took' },
    [types_1.ItemTypes.FURNITURE]: DropArray,
    [types_1.ItemTypes.PLANTABLE]: ['plant'],
    [types_1.ItemTypes.TREE]: [],
};
exports.PlatableGameData = {
    'seeds1': {
        flower: 'flower1',
        timeToGrow: [1000, 2500],
        beeFactor: 1,
        spawnRate: 10000,
    },
    'seeds2': {
        flower: 'flower2',
        timeToGrow: [1500, 5500],
        beeFactor: 1.5,
        spawnRate: 15000,
    },
    'seeds3': {
        flower: 'flower3',
        timeToGrow: [2000, 9000],
        beeFactor: 5,
        spawnRate: 25000,
    },
    'seeds4': {
        flower: 'flower4',
        timeToGrow: [2500, 15000],
        beeFactor: 10,
        spawnRate: 50000,
    },
};
exports.START_POSITIONS = {
    nomTook: { x: 1115, y: 770, direction: 'south' },
    player: { x: 1115, y: 970, direction: 'north' }
};
exports.TOM_NOOK_SHOP_POSITION = { x: exports.START_POSITIONS.nomTook.x, y: exports.START_POSITIONS.nomTook.y + 430 };
exports.NOM_TOOK_WALK_TO_YOU = { x: exports.START_POSITIONS.nomTook.x, y: exports.START_POSITIONS.player.y - 30, direction: 'south' };
exports.WALK_TO_HOUSE_PATHS = {
    player: [
        { x: exports.START_POSITIONS.player.x + 30, y: exports.START_POSITIONS.player.y, direction: 'east' },
        { x: exports.START_POSITIONS.player.x, y: exports.START_POSITIONS.player.y, direction: 'west' },
        { x: exports.START_POSITIONS.player.x, y: exports.START_POSITIONS.player.y + 200, direction: 'south' },
        { x: exports.START_POSITIONS.player.x + 30, y: exports.START_POSITIONS.player.y + 200, direction: 'east' },
        { x: exports.START_POSITIONS.player.x + 30, y: exports.START_POSITIONS.player.y + 250, direction: 'south' },
        { x: exports.START_POSITIONS.player.x, y: exports.START_POSITIONS.player.y + 250, direction: 'west' },
        { x: exports.START_POSITIONS.player.x, y: exports.START_POSITIONS.player.y + 250, direction: 'north' } // look at nom.
    ],
    nomTook: [{ x: exports.START_POSITIONS.nomTook.x, y: exports.TOM_NOOK_SHOP_POSITION.y, direction: 'south' }],
};
const FlowerItemData = {
    type: types_1.ItemTypes.FLOWER,
};
exports.ShopItemData = [
    { name: 'red_bed', label: 'Red Bed', cost: 5000 },
    { name: 'blue_bed', label: 'Blue Bed', cost: 5000 },
    { name: 'green_bed', label: 'Green Bed', cost: 5000 },
    { name: 'plant', label: 'House Plant', cost: 5000 }
];
exports.GlobalGameData = {
    items: {
        'tree': {
            type: types_1.ItemTypes.TREE
        },
        'butterfly': {
            type: types_1.ItemTypes.BUG,
            shop: {
                sellPrice: 1500,
            },
        },
        'bee': {
            type: types_1.ItemTypes.BUG,
            shop: {
                sellPrice: 1000,
            },
        },
        'shovel': ToolData,
        'net': ToolData,
        'axe': ToolData,
        'red_bed': BedFurnitureData,
        'blue_bed': BedFurnitureData,
        'green_bed': BedFurnitureData,
        'seeds1': SeedInventoryData,
        'seeds2': SeedInventoryData,
        'seeds3': SeedInventoryData,
        'seeds4': SeedInventoryData,
        'pedals1': {
            type: types_1.ItemTypes.RESOURCE,
            shop: {
                sellPrice: 100,
            }
        },
        'pedals2': {
            type: types_1.ItemTypes.RESOURCE,
            shop: {
                sellPrice: 150,
            }
        },
        'pedals3': {
            type: types_1.ItemTypes.RESOURCE,
            shop: {
                sellPrice: 250,
            }
        },
        'pedals4': {
            type: types_1.ItemTypes.RESOURCE,
            shop: {
                sellPrice: 500,
            }
        },
        'flower1': FlowerItemData,
        'flower2': FlowerItemData,
        'flower3': FlowerItemData,
        'flower4': FlowerItemData,
    }
};
function addDefaultTrees(startUid, grassRects, treeCount) {
    const c = [];
    let lastUid = startUid;
    for (let uid = startUid; uid < startUid + treeCount; uid++) {
        let rect = Utils_1.getRandomItemFromArray(grassRects);
        let point = Utils_1.getRandomPositionFromRect(rect);
        let curTreeRect = { x: point.x - 30, y: point.y - 30, w: 60, h: 60 };
        while (c.find(p => {
            const checkTreeRect = { x: p.x - 30, y: p.y - 30, w: 60, h: 60 };
            return Utils_1.rectsAreColliding(checkTreeRect, curTreeRect);
        })) {
            rect = Utils_1.getRandomItemFromArray(grassRects);
            point = Utils_1.getRandomPositionFromRect(rect);
            curTreeRect = { x: point.x - 30, y: point.y - 30, w: 60, h: 60 };
        }
        c.push(Object.assign(Object.assign({}, point), { uid }));
        lastUid = uid;
    }
    return { array: c, lastUid };
}
exports.addDefaultTrees = addDefaultTrees;
function addDefaultFlowers(startUid, grassRects, counts, treePositions) {
    const c = [];
    let lastUid = startUid;
    const treeRects = treePositions.map(t => {
        return { x: t.x - 30, y: t.y - 30, w: 80, h: 80 };
    });
    for (let i = 0; i < counts.length; i++) {
        c[i] = [];
        for (let ii = 0; ii < counts[i]; ii++) {
            const rect = Utils_1.getRandomItemFromArray(grassRects);
            let point = Utils_1.getRandomPositionFromRect(rect, -20, -20, -30, -30);
            // @ts-ignore
            const flowerRects = [...c].flat().map(c2 => {
                return { x: c2.x - 5, y: c2.y - 5, w: 10, h: 10 };
            });
            while ([...flowerRects, ...treeRects].find(r => {
                return Utils_1.rectContainsPoint(r, point);
            })) {
                point = Utils_1.getRandomPositionFromRect(rect);
            }
            c[i].push(Object.assign(Object.assign({}, point), { uid: ++lastUid }));
        }
    }
    return { array: c, lastUid };
}
exports.addDefaultFlowers = addDefaultFlowers;
function defaultGameData(playerName, grassRects, numberOfTrees = 20, numberOfFlowers = [5, 3, 2, 1]) {
    playerName = playerName || 'Player';
    const startingTrees = addDefaultTrees(0, grassRects, numberOfTrees);
    const startingFlowers = addDefaultFlowers(startingTrees.lastUid, grassRects, numberOfFlowers, startingTrees.array);
    const startingTreeGameStateArray = startingTrees.array.map(tree => {
        return Object.assign(Object.assign({}, tree), { name: 'tree', x: tree.x, y: tree.y, uid: tree.uid, state: {
                growth: 2,
                type: 'basic'
            } });
    });
    const startingFlowerGameStateArray = startingFlowers.array.map((a, i) => {
        return a.map(f => {
            return Object.assign(Object.assign({}, f), { name: `flower${i + 1}`, state: {
                    plantedByPlayer: false,
                    elapsedTimeAlive: 99999,
                } });
        });
        // @ts-ignore
    }).flat();
    const startingIslandData = {
        name: "island",
        droppableItems: [types_1.ItemTypes.FURNITURE, types_1.ItemTypes.RESOURCE, types_1.ItemTypes.TREE, types_1.ItemTypes.PLANTABLE, types_1.ItemTypes.BUG],
        state: {
            items: [
                ...startingTreeGameStateArray,
                ...startingFlowerGameStateArray
            ],
            holes: [],
        }
    };
    return {
        totalElapsedTime: 0,
        lastUid: startingFlowers.lastUid,
        honey: 0,
        playerName,
        levels: [{
                name: 'home',
                isHome: true,
                droppableItems: [types_1.ItemTypes.FURNITURE, types_1.ItemTypes.RESOURCE],
                state: {
                    items: [],
                    wall: 'default',
                    floor: 'default',
                }
            }, startingIslandData],
        house: { wall: 'default', floor: 'default', items: [] },
        npcData: {
            nomTook: {
                level: 'island',
                position: { x: exports.START_POSITIONS.nomTook.x, y: exports.START_POSITIONS.nomTook.y },
                task: 0,
                direction: 'south'
            },
            honeyBear: {
                level: 'island',
                position: { x: exports.START_POSITIONS.nomTook.x, y: exports.START_POSITIONS.nomTook.y },
                task: 0,
                direction: 'south'
            }
        },
        level: 'island',
        direction: exports.START_POSITIONS.player.direction,
        position: {
            x: exports.START_POSITIONS.player.x,
            y: exports.START_POSITIONS.player.y,
        },
        inventory: []
    };
}
exports.defaultGameData = defaultGameData;
//# sourceMappingURL=module.js.map